import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [mode, setMode] = useState('light');
  // P1+ uses a single fixed palette (blue→teal), no color scheme switching
  const colorScheme = 'blue';

  useEffect(() => {
    const savedMode = localStorage.getItem('theme-mode') || 'light';
    setMode(savedMode);
    applyTheme(savedMode);
  }, []);

  const applyTheme = (themeMode) => {
    const root = document.documentElement;
    if (themeMode === 'dark') {
      root.classList?.add('dark');
    } else {
      root.classList?.remove('dark');
    }
    root.setAttribute('data-color-scheme', 'blue');
  };

  const toggleMode = () => {
    const newMode = mode === 'light' ? 'dark' : 'light';
    setMode(newMode);
    localStorage.setItem('theme-mode', newMode);
    applyTheme(newMode);
  };

  // No-op kept for backward compatibility
  const switchColorScheme = () => {};

  const value = {
    mode,
    colorScheme,
    toggleMode,
    switchColorScheme,
    isDark: mode === 'dark',
    isGreen: false,
    isBlue: true
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};